// extracted by mini-css-extract-plugin
export default {"question":"styles_question__4ruJ8","questionWrap":"styles_questionWrap__bywHj","nextBtn":"styles_nextBtn__HYDph","scaleWrap":"styles_scaleWrap__y6Ugc"};